import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PrerequisitesGuard, PrerequisitesWithoutDeleteCheckGuard } from './guards/prerequisites.guard';
import { DownloadComponent } from './components/download/download.component';
import { CaseSelectComponent } from './components/case/case-select/case-select.component';
import { LoginComponent } from './components/identity/login/login.component';
import { ForgotPasswordComponent } from './components/identity/forgot-password/forgot-password.component';
import { LoginChallengeComponent } from './components/identity/login-challenge/login-challenge.component';
import { LoginMfaSelectionComponent } from './components/identity/login-mfa-selection/login-mfa-selection.component';
import { ManagePasswordComponent } from './components/identity/manage-password/manage-password.component';
import { AvailabilityGuard } from './guards/availability.guard';
import { AppContainerComponent } from "./components/layout/app-container/app-container.component";
import { UserConfirmDownloadComponent } from './components/export/user-confirm-download/user-confirm-download.component';

const appRoutes: Routes = [
	{
		path: '',
		canActivate: [AvailabilityGuard],
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full'
			},
			{
				path: 'identity',
				children: [
					{
						path: '',
						redirectTo: 'login',
						pathMatch: 'full'
					},
					{
						path: 'confirm',
						component: ManagePasswordComponent
					},
					{
						path: 'recovery',
						component: ManagePasswordComponent
					},
					{
						path: 'login',
						component: LoginComponent
					},
					{
						path: 'login-challenge',
						component: LoginChallengeComponent
					},
					{
						path: 'mfa-selection',
						component: LoginMfaSelectionComponent
					},
					{
						path: 'forgot-password',
						component: ForgotPasswordComponent
					}
				]
			},
			{
				path: 'dashboard',
				component: AppContainerComponent,
				canActivate: [PrerequisitesGuard],
				children: [
					{
						path: '',
						component: DashboardComponent,
					}
				]
			},
			{
				path: 'select-case',
				component: CaseSelectComponent,
				canActivate: [PrerequisitesWithoutDeleteCheckGuard]
			},
			{
				path: 'management',
				loadChildren: () => import('./components/management/management.module').then(m => m.ManagementModule),
				canActivate: [PrerequisitesGuard]
			},
			{
				path: 'upload',
				loadChildren: () => import('./components/uploader/uploader.module').then(m => m.UploaderModule),
				canActivate: [PrerequisitesGuard]
			},
			{
				path: 'status',
				loadChildren: () => import('./components/app-offline/app-offline.module').then(m => m.AppOfflineModule)
			},
			{
				path: 'review/doc-viewer',
				loadChildren: () => import('./components/doc-viewer-new/doc-viewer.module').then(m => m.DocViewerModule)
			},
			{
				path: 'download/:id',
				component: DownloadComponent
			},
			{
				path: 'download-production/:id',
				redirectTo: 'verified-download/:id',
				pathMatch: 'full'
			},
			{
				path: 'verified-download/:id',
				component: UserConfirmDownloadComponent 
			}
		]
	},
];

@NgModule({
	imports: [RouterModule.forChild(appRoutes)],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
